import {ParseResolver} from '../interfaces/parse-resolver';
import { SimpleParseResolver } from '../simple-parse-resolver';

export abstract class DataField {
  //This is used to key off of things.
  id: string;

  //This is what would show up in UI.
  title: string;

  //This is how the data field extracts data out of an object row.
  //Something like 'name.first'
  objectLookupKey: string;

  objectLookupFunction: (Object) => any;

  parseResolver: ParseResolver;

  //Can be set to false to prevent console.error from printing exceptions
  //thrown by calling objectLookupFunction.
  //Created for unit tests, but also may be useful for other developers.
  logLookupFunctionExceptions = true;

  constructor(id: string, objectLookup: string | ((Object) => any), title: string) {
    this.id = id;

    if (typeof objectLookup === 'string') {
      this.objectLookupKey = <any>objectLookup;
      this.parseResolver = new SimpleParseResolver(this.objectLookupKey);
    } else {
      this.objectLookupKey = 'using lookup function';
      this.objectLookupFunction = objectLookup;
    }

    this.title = title;

    //No starting with a - because that is used for reverse sorting.
    if (!/^[0-9a-z\][0-9a-z\-]*$/.test(id)) {
      throw 'id "' + id + '" must contain only a-z, 0-9, and -.  Also, cannot start with -';
    }
  }

  resolve(dataRow: any): any {
    if (dataRow == null) {
      return;
    }

    if (this.objectLookupFunction != null) {
      try {
        //Always called on the window on purpose.
        return this.objectLookupFunction.call(window, dataRow);
      } catch (error) {
        if (this.logLookupFunctionExceptions) {
          console.error(error);
        }
        return;
      }
    }

    return this.parseResolver.resolve(dataRow);
  }

  abstract resolveAsString(dataRow: any): string;
}
